import {titleCase} from "../../filters/titlecase";
import {conversationCellRenderer, messageCellRenderer, ResourceCellRenderer} from '../../directives';
import {
  AccountService,
  CollectionService,
  Factory, IConfigService, IHttpWrapperService,
  INotificationService,
  OrganizationService,
  PreferenceService,
  ProjectService,
  ResourceService,
  TagFormService,
  TagService,
  TranslationService
} from '../../services';
import {Status} from '../../model/project/Status';
import {DisplayMode, Preferences} from '../../model/user/Preferences';
import {SearchTermGroupedItem} from '../../model/terms/SearchTermGroupedItem';
import {SearchTermListGroupedItem} from '../../model/terms/SearchTermListGroupedItem';
import {GroupedType} from '../../model/controls/grid/GroupedType';
import {SearchTermList} from '../../model/terms/SearchTermList';
import {SearchTerm} from '../../model/terms/SearchTerm';
import {IResource} from "../../model/resources/IResource";

export class ResourceController {
  private _loadGeneration = 0;

  constructor($rootScope, $scope, $uibModal, $sce, $http, window, private $timeout, $compile, hotkeys, private projectService: ProjectService, private organizationService: OrganizationService, private collectionService: CollectionService, private resourceService: ResourceService, resourceText, resourceNoteService, navigationService, layerService, tagService: TagService, accountService: AccountService, configService: IConfigService, httpService: IHttpWrapperService, private notificationService: INotificationService, tagFormService: TagFormService, private translationService: TranslationService, preferenceService: PreferenceService) {
    const resetPreview = () => {
      $scope.plainSrc = $sce.trustAsResourceUrl("");
      $scope.pdfSrc = $sce.trustAsResourceUrl("");
      $scope.richSrc = $sce.trustAsResourceUrl("");
      $scope.annotatedPlainSrc = $sce.trustAsResourceUrl("");
      $scope.translation.translatedText = "";
      $scope.resource = null;
      $scope.threads = [];
      $scope.highlights = [];
      $scope.$selectedSnippetIndex = -1;
      $scope.termHighlights = {
        term: "",
        snippets: [],
        selectedIndex: -1
      };
      $scope.tagForm = null;
      $scope.player.isPlayable = false;
      $scope.player.src = null;
    };
    const messageDataSource = {
      getRows: async params => {
        if ($scope.chatMessageId) {
          const response = await resourceService.GetMessages($scope.resource, $scope.chatMessageId, Math.floor(params.request.startRow / $scope.messagesPageSize), $scope.messagesPageSize);
          $scope.messagesHighlightFocusedRow = false;
          params.successCallback(response.messages, response.total);
        }
      }
    };
    const refreshNotes = () => $scope.notes = resourceNoteService.findAll(current.projectId, current.collectionId, current.resourceId);
    const configurePlayer = () => {
      $scope.player.isPlayable = false;
      $scope.player.isVideo = false;
      $scope.player.isAudio = false;

      // Pass the URL as a plain string so videogular skips canPlayType()
      $scope.player.src = resourceText.playerSrc(current.projectId, current.collectionId, current.resourceId);

      $scope.player.themeUrl = "/videogular.min.css";
      if ($scope.resource) {
        $scope.player.isPlayable = $scope.resource.mimeType.indexOf("audio") > -1 || $scope.resource.mimeType.indexOf("video") > -1;
        if ($scope.resource.mimeType.indexOf("audio") > -1) {
          $scope.player.isAudio = true;
          $scope.player.isVideo = false;
        } else if ($scope.resource.mimeType.indexOf("video") > -1) {
          $scope.player.isVideo = true;
          $scope.player.isAudio = false;
        }
      }
    };

    let current = {
      projectId: "",
      collectionId: "",
      resourceId: ""
    };

    window["current"] = window;

    $scope.radioModel = {selectedValue: "namedEntities"};
    $scope.Status = Status;
    $scope.DisplayMode = DisplayMode;
    $scope.tooltipText = "";
    $scope.listViewColumnDefinitions = PreferenceService.DefaultGridColumns();
    $scope.highlightedCategories = [];
    $scope.highlightedEntities = [];

    $scope.groupRowCellRenderer = params => {
      params.$scope.expanded = params.node.expanded;
      params.$scope.preview = $scope.preview;

      params.$scope.highlightCategory = () => {
        const annotatedTextContainer = $(".annotated-text");

        if (annotatedTextContainer.length === 0) {
          return;
        }

        if ($scope.highlightedCategories.includes(params.value)) {
          $scope.highlightedCategories = _.without($scope.highlightedCategories, params.value);
          $(`.fa-highlighter.${params.value}`).removeClass(`highlight-${params.value}`)
        } else {
          $scope.highlightedCategories.push(params.value);
          $(`.fa-highlighter.${params.value}`).addClass(`highlight-${params.value}`)
        }

        annotatedTextContainer.removeClass();
        annotatedTextContainer.addClass(`annotated-text`);

        $scope.highlightedEntities.forEach(e => e.removeClass());
        $scope.highlightedCategories.forEach(c => {
          annotatedTextContainer.addClass(`highlight-${c}`)
        });
      }

      params.$scope.toggleGroupRowExpandedState = () => {
        params.node.setExpanded(!params.node.expanded);
        params.$scope.expanded = params.node.expanded;
      };
      const expandCollapseButtons = () => {
        return `
<span ng-click="toggleGroupRowExpandedState()" style="margin-right: 15px">
    <i class="fas fa-plus-square" ng-hide="expanded"></i>
    <i class="fas fa-minus-square" ng-show="expanded"></i>
</span>`;
      }

      // Guard against undefined type for group rows
      if (!params.data?.type) {
        return `${expandCollapseButtons()} ${params.value}`;
      }

      switch (params.value) {
        case "organization":
          return `${expandCollapseButtons()} <i class="far fa-building fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "phone":
          return `${expandCollapseButtons()} <i class="fas fa-mobile-alt fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "person":
          return `${expandCollapseButtons()} <i class="fas fa-male fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "money":
          return `${expandCollapseButtons()} <i class="far fa-money-bill-alt fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "location":
          return `${expandCollapseButtons()} <i class="fas fa-map-pin fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "percent":
          return `${expandCollapseButtons()} <i class="fas fa-percent fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "date":
          return `${expandCollapseButtons()} <i class="far fa-calendar-alt fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "time":
          return `${expandCollapseButtons()} <i class="far fa-clock fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "event":
          return `${expandCollapseButtons()} <i class="fas fa-calendar-check fa-fw"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        case "commercial_item":
          return `${expandCollapseButtons()} <i class="far fa-building"></i> ${params.data.type.displayName} <span ng-click="highlightCategory()"><i ng-if="preview.type === 'Plain'" class="fas fa-highlighter ${params.value} pull-right"></i></span>`;
        default:
          return `${expandCollapseButtons()} ${params.data.type.displayName}`;
      }
    }
    $scope.namedEntitiesColumnDefinitions = [
      {
        field: "type.value",
        rowGroup: true,
        hide: true
      },
      {
        field: "value",
        showRowGroup: true,
        cellRenderer: "agGroupCellRenderer"
      }
    ];

    $scope.searchTermListsColumnDefinitions = [
      {
        field: "type.value",
        rowGroup: true,
        hide: true
      },
      {
        field: "value",
        showRowGroup: true,
        cellRenderer: "agGroupCellRenderer"
      }
    ];

    $scope.resourceCellRenderer = ResourceCellRenderer;
    $scope.conversationCellRenderer = conversationCellRenderer;
    $scope.messageCellRenderer = messageCellRenderer;
    $scope.conversationsColumnDefinitions = [];
    $scope.messagesColumnDefinitions = [];
    $scope.chatMessageId = "";
    $scope.messagesPageSize = 20;
    $scope.conversationsFocusRowIndex = 0;

    $scope.getRowHeight = (params, columnWidth) => {
      if (params && columnWidth) {
        const pre = $("<pre/>").html(params.data.text);
        const div = $(`<div class="chat" style="width: ${columnWidth}"></div>`);

        div.append(pre);

        $(document.body).append(div);

        let height = 100.8 + pre.outerHeight();

        div.remove();

        if (params.data.attachments) {
          params.data.attachments.forEach(a => {
            if (a.contentType?.includes("audio")) {
              height += 50;
            } else if (a.infected || (!a.contentType?.includes('video') && !a.imageType)) {
              height += 185;
            } else {
              height += 265;
            }
          });
        }

        return height;
      }

      return 75;
    };

    $scope.preview = {
      type: "Pdf",
      maximized: false,
      translate: false,
      tagAdvanced: false
    };

    $scope.newResourceNote = {
      note: ""
    };

    $scope.accountService = accountService;

    $scope.translation = {};

    $scope.player = {
      isPlayable: false,
      isAudio: false,
      isVideo: false,
      API: null
    };

    $scope.similarCfg = {
      query: false
    }

    $scope.pendingChanges = {redaction: false, notes: false};

    $scope.noteCategoryConfig = {
      selected: {"id": "Regular", "label": "Regular"},
      categories: [
        {"id": "Regular", "label": "Regular"},
        {"id": "Privileged", "label": "Privileged Log Note"}
      ]
    };

    $scope.selectNoteCategory = category => $scope.noteCategoryConfig.selected = category;

    $scope.viewMessageInConversation = () => {
      $scope.messagesDataSource = null;
      $scope.viewInConversation = true;
      resourceService.GetConversationIndex($scope.resource).then(indexResponse => $scope.conversationsFocusRowIndex = +indexResponse.data);

      resourceService.GetMessageIndex($scope.resource).then(indexResponse => {
        $timeout(() => {
          $scope.messagesFocusRowIndex = +indexResponse.data;
          $scope.messagesHighlightFocusedRow = true;

          $scope.messagesDataSource = {
            getRows: async params => {
              const response = await resourceService.GetMessages($scope.resource, $scope.resource.chatMessageId, Math.floor(params.request.startRow / $scope.messagesPageSize), $scope.messagesPageSize);
              params.successCallback(response.messages, response.total);

              $timeout(() => $scope.messagesFocusRowIndex = null, 1500);
            }
          };
        });
      });
    };

    $scope.translationConfig = {
      sourceLanguage: {"id": "detect", "label": "Detect Language"},
      languages: [
        {"id": "detect", "label": "Detect Language"},
        {"id": "af", "label": "Afrikaans"},
        {"id": "sq", "label": "Albanian"},
        {"id": "am", "label": "Amharic"},
        {"id": "ar", "label": "Arabic"},
        {"id": "hy", "label": "Armenian"},
        {"id": "az", "label": "Azeerbaijani"},
        {"id": "eu", "label": "Basque"},
        {"id": "be", "label": "Belarusian"},
        {"id": "bn", "label": "Bengali"},
        {"id": "bs", "label": "Bosnian"},
        {"id": "bg", "label": "Bulgarian"},
        {"id": "ca", "label": "Catalan"},
        {"id": "ceb", "label": "Cebuano"},
        {"id": "zh-CN", "label": "Chinese (Simplified)"},
        {"id": "zh-TW", "label": "Chinese (Traditional)"},
        {"id": "co", "label": "Corsican"},
        {"id": "hr", "label": "Croatian"},
        {"id": "cs", "label": "Czech"},
        {"id": "da", "label": "Danish"},
        {"id": "nl", "label": "Dutch"},
        {"id": "eo", "label": "Esperanto"},
        {"id": "et", "label": "Estonian"},
        {"id": "fi", "label": "Finnish"},
        {"id": "fr", "label": "French"},
        {"id": "fy", "label": "Frisian"},
        {"id": "gl", "label": "Galician"},
        {"id": "ka", "label": "Georgian"},
        {"id": "de", "label": "German"},
        {"id": "el", "label": "Greek"},
        {"id": "gu", "label": "Gujarati"},
        {"id": "ht", "label": "Haitian Creole"},
        {"id": "ha", "label": "Hausa"},
        {"id": "haw", "label": "Hawaiian"},
        {"id": "iw", "label": "Hebrew"},
        {"id": "hi", "label": "Hindi"},
        {"id": "hmn", "label": "Hmong"},
        {"id": "hu", "label": "Hungarian"},
        {"id": "is", "label": "Icelandic"},
        {"id": "ig", "label": "Igbo"},
        {"id": "id", "label": "Indonesian"},
        {"id": "ga", "label": "Irish"},
        {"id": "it", "label": "Italian"},
        {"id": "ja", "label": "Japanese"},
        {"id": "jw", "label": "Javanese"},
        {"id": "kn", "label": "Kannada"},
        {"id": "kk", "label": "Kazakh"},
        {"id": "km", "label": "Khmer"},
        {"id": "ko", "label": "Korean"},
        {"id": "ku", "label": "Kurdish"},
        {"id": "ky", "label": "Kyrgyz"},
        {"id": "lo", "label": "Lao"},
        {"id": "la", "label": "Latin"},
        {"id": "lv", "label": "Latvian"},
        {"id": "lt", "label": "Lithuanian"},
        {"id": "lb", "label": "Luxembourgish"},
        {"id": "mk", "label": "Macedonian"},
        {"id": "mg", "label": "Malagasy"},
        {"id": "ms", "label": "Malay"},
        {"id": "ml", "label": "Malayalam"},
        {"id": "mi", "label": "Maori"},
        {"id": "mr", "label": "Marathi"},
        {"id": "mn", "label": "Mongolian"},
        {"id": "my", "label": "Myanmar (Burmese)"},
        {"id": "ne", "label": "Nepali"},
        {"id": "no", "label": "Norwegian"},
        {"id": "ny", "label": "Nyanja (Chichewa)"},
        {"id": "ps", "label": "Pashto"},
        {"id": "fa", "label": "Persian"},
        {"id": "pl", "label": "Polish"},
        {"id": "pt", "label": "Portuguese"},
        {"id": "pa", "label": "Punjabi"},
        {"id": "ro", "label": "Romanian"},
        {"id": "ru", "label": "Russian"},
        {"id": "sm", "label": "Samoan"},
        {"id": "gd", "label": "Scots Gaelic"},
        {"id": "sr", "label": "Serbian"},
        {"id": "st", "label": "Sesotho"},
        {"id": "sn", "label": "Shona"},
        {"id": "sd", "label": "Sindhi"},
        {"id": "si", "label": "Sinhala (Sinhalese)"},
        {"id": "sk", "label": "Slovak"},
        {"id": "sl", "label": "Slovenian"},
        {"id": "so", "label": "Somali"},
        {"id": "es", "label": "Spanish"},
        {"id": "su", "label": "Sundanese"},
        {"id": "sw", "label": "Swahili"},
        {"id": "sv", "label": "Swedish"},
        {"id": "tl", "label": "Tagalog (Filipino)"},
        {"id": "tg", "label": "Tajik"},
        {"id": "ta", "label": "Tamil"},
        {"id": "te", "label": "Telugu"},
        {"id": "th", "label": "Thai"},
        {"id": "tr", "label": "Turkish"},
        {"id": "uk", "label": "Ukrainian"},
        {"id": "ur", "label": "Urdu"},
        {"id": "uz", "label": "Uzbek"},
        {"id": "vi", "label": "Vietnamese"},
        {"id": "cy", "label": "Welsh"},
        {"id": "xh", "label": "Xhosa"},
        {"id": "yi", "label": "Yiddish"},
        {"id": "yo", "label": "Yoruba"},
        {"id": "zu", "label": "Zulu"}
      ]
    };

    $scope.selectLanguage = lang => $scope.translationConfig.sourceLanguage = lang;

    // ── ResourceViewer navigation state ───────────────────────────────────────────
    // These are the single source of truth for the current document position
    // and total count.  They live entirely inside ResourceController's closure
    // so they survive BrowseController being re-instantiated (which rebuilds
    // the grid and nulls its api).  The grid api is only used for the visual
    // side-effects (scroll, focus) and never as a source of truth.
    //
    // _browseIndex lives on $rootScope so both the inline and detached viewer
    // ResourceController instances always share the same browse position.
    $rootScope['_browseIndex'] = $rootScope['_browseIndex'] || 0;
    let _browseTotalRows: number = 0;
    let _browseApi: any = null;
    let _browseColumnApi: any = null;
    // Set when gridNavigateRows fires but the target block isn't loaded yet
    // (or _browseApi is null).  Cleared once navigation actually completes.
    let _pendingNavIndex: number | null = null;
    // Pending debounce timer for InitializeScope — cancelled on each new navigation
    // so rapid Next/Previous clicks only trigger one metadata+file load.
    let _initScopeTimeout: angular.IPromise<void> | null = null;
    const INIT_SCOPE_DEBOUNCE_MS = 250;

    // Clear the stale browse grid api whenever the route changes away from a
    // browse-capable page.  Prevents refreshInfiniteCache() and similar calls
    // from firing on a destroyed ag-Grid instance after the user navigates.
    $rootScope.$on('$routeChangeStart', (_event, next) => {
      // While the resource viewer is the active layer, all route changes are
      // spurious — they are fired by ag-Grid's $applyAsync / pagination flush
      // during Next/Previous navigation while the browse/search grid is still
      // alive in the background.  Clearing the API reference here would break
      // the very next navigation attempt.  The viewer is always closed (and
      // the layer popped) before any real navigation away from the grid page,
      // so by the time a genuine route change fires the layer guard is gone.
      // Same logic applies when the viewer is detached: the search grid stays
      // alive in the background and its _browseApi must be preserved.  Unlike
      // browse (which lives in ng-view and is recreated by the route change),
      // the search grid lives in ng-show and is never recreated, so
      // DataGridReadyEvent never refires to restore _browseApi after it's cleared.
      if (layerService.layer.current === layerService.LAYERS.RESOURCE || $rootScope.viewerDetached) {
        return;
      }
      const nextPath = next && next.$$route && next.$$route.originalPath || '';
      // Routes where the browse/search grid (and its API) remain alive.
      const navRoutes = [
        '/project/:projectId/browse',
        '/project/:projectId/home/batch/:batchId',
        '/project/:projectId/home/batch/:batchId/:reviewState',
        '/project/:projectId/search',
        '/project/:projectId/collection/:collectionId/search',
        '/project/:projectId/home/search/:searchId',
      ];
      if (!navRoutes.includes(nextPath)) {
        _browseApi = null;
        _browseColumnApi = null;
        _pendingNavIndex = null;
        if (_initScopeTimeout) {
          $timeout.cancel(_initScopeTimeout);
          _initScopeTimeout = null;
        }
      }
    });

    // Called whenever the browse grid (re)initialises.  Refreshes the api
    // reference and re-syncs the total.  home_results.html grids must carry
    // grid-name="browse" for this to fire for the right grid.
    $rootScope.$on("DataGridReadyEvent", (_, data) => {
      if (data.name === "browse" || data.name === "search") {
        _browseApi = data.api;
        _browseColumnApi = data.columnApi;
        // Pull an up-to-date total from the newly-ready grid (it may have
        // already requested the first page by the time this fires).
        const fresh = data.api.getInfiniteRowCount();
        if (fresh > 0) {
          _browseTotalRows = fresh;
        }
        // Keep $scope.index in sync so the template re-renders with the
        // correct value after a BrowseController reconstruct.
        $scope.index = $rootScope['_browseIndex'];
        // If navigation was parked because the api was null, retry now.
        if (_pendingNavIndex !== null) {
          $scope.gridNavigateRows();
        }
      }
    });

    // Fired by dataGrid.ts each time a block of rows arrives from the server.
    // Updates _browseTotalRows and completes any parked navigation whose target
    // row is in the arrived block.  The resource is extracted directly from the
    // event payload (data.rows) rather than via getDisplayedRowAtIndex() to
    // avoid any dependency on ag-Grid's display layer being ready yet.
    $rootScope.$on("DataGridBlockLoadedEvent", (_, data) => {
      if (data.name !== "browse" && data.name !== "search") {
        return;
      }
      if (typeof data.totalRows === "number" && data.totalRows > 0) {
        _browseTotalRows = data.totalRows;
      }
      if (_pendingNavIndex !== null && data.rows) {
        const blockEnd = data.startRow + data.rows.length;
        if (_pendingNavIndex >= data.startRow && _pendingNavIndex < blockEnd) {
          const resource = data.rows[_pendingNavIndex - data.startRow];
          if (resource) {
            const navIndex = _pendingNavIndex;
            _pendingNavIndex = null;
            $scope.index = navIndex;
            $rootScope.$broadcast("ResourceService.LaunchFullView", {
              projectId: resource.projectId,
              collectionId: resource.collectionId,
              resourceId: resource.id,
              title: resource.title,
              filename: resource.filename,
              type: resource.type,
              hasVirus: resource.hasVirus,
            });
            // Defer grid visual update (focus cell highlight) until ag-Grid
            // has rendered the new block — the viewer update above is already
            // complete and doesn't need to wait.
            this.$timeout(() => {
              if (_browseApi) {
                const columns = _browseColumnApi && _browseColumnApi.getAllDisplayedColumns();
                if (columns && columns.length) {
                  _browseApi.setFocusedCell(navIndex, columns[0]);
                }
              }
            }, 0);
          }
        }
      }
    });

    // Fired by BrowseController.ReloadResourceData() after a tag/filter change
    // that doesn't require a full datasource replacement.  refreshInfiniteCache
    // keeps existing rows visible (no spinner) while re-fetching each block.
    $rootScope.$on("BrowseGrid.SoftRefresh", () => {
      if (_browseApi) {
        // Defer to avoid calling the cache refresh while ag-Grid is
        // mid-render ("cannot get grid to draw rows" error).
        this.$timeout(() => {
          _browseApi && _browseApi.refreshInfiniteCache();
        }, 0);
      }
    });

    // Scrolls/focuses the browse grid at the current _browseIndex then
    // broadcasts the matching resource into the viewer.  Does NOT reset
    // _browseIndex — callers (gridNextRow / gridPreviousRow) own that.
    // If the grid API is absent, or the target row's block isn't loaded yet,
    // parks the index in _pendingNavIndex so the relevant event listener can
    // retry once the API or data is available.
    $scope.gridNavigateRows = () => {
      if (!_browseApi) {
        // API not ready — park and wait for DataGridReadyEvent to retry.
        _pendingNavIndex = $rootScope['_browseIndex'];
        return;
      }

      // Ensure the infinite row model has allocated a block for this index.
      if (_browseApi.getInfiniteRowCount() <= $rootScope['_browseIndex']) {
        _browseApi.setInfiniteRowCount($rootScope['_browseIndex'] + 1, false);
      }

      _browseApi.ensureIndexVisible($rootScope['_browseIndex']);

      const node = _browseApi.getDisplayedRowAtIndex($rootScope['_browseIndex']);
      const resource = node && node.data;

      if (!resource) {
        // Block not loaded yet.  ensureIndexVisible/setInfiniteRowCount has
        // queued a fetch — park the index so DataGridBlockLoadedEvent retries.
        _pendingNavIndex = $rootScope['_browseIndex'];
        return;
      }

      // Navigation is actually completing — update counter and clear pending.
      _pendingNavIndex = null;
      $scope.index = $rootScope['_browseIndex'];

      // Broadcast without a grid/index so the LaunchFullView handler knows
      // this is programmatic navigation and does NOT reset _browseIndex.
      $rootScope.$broadcast("ResourceService.LaunchFullView", {
        projectId: resource.projectId,
        collectionId: resource.collectionId,
        resourceId: resource.id,
        title: resource.title,
        filename: resource.filename,
        type: resource.type,
        hasVirus: resource.hasVirus,
      });

      const columns = _browseColumnApi && _browseColumnApi.getAllDisplayedColumns();
      if (columns && columns.length) {
        _browseApi.setFocusedCell($rootScope['_browseIndex'], columns[0]);
      }
    };

    $scope.showResourceForSelectedMessage = message => {
      $scope.viewInConversation = false;

      $scope.$broadcast("ResourceService.LaunchFullView", {
        projectId: current.projectId,
        collectionId: current.collectionId,
        resourceId: message.resourceId
      });
    }

    $scope.disregardChanges = () => {
      $scope.pendingChanges.redaction = false;
      $scope.pendingChanges.notes = false;
      $scope.instance.close();
      $scope.gridNextRow();
    };

    $scope.gridNextRow = () => {
      if ($scope.pendingChanges.redaction || $scope.pendingChanges.notes) {
        $scope.instance = $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/controls/pending-redactions-notes.html",
          scope: $scope,
          appendTo: $(window.current.document.body)
        });
      } else {
        if ($rootScope['_browseIndex'] < _browseTotalRows - 1) {
          $rootScope['_browseIndex']++;
          $scope.gridNavigateRows();
        }
      }
    };

    $scope.gridPreviousRow = () => {
      if ($scope.pendingChanges.redaction || $scope.pendingChanges.notes) {
        $scope.instance = $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/controls/pending-redactions-notes.html",
          scope: $scope,
          appendTo: $(window.current.document.body)
        });
      } else {
        if ($rootScope['_browseIndex'] > 0) {
          $rootScope['_browseIndex']--;
          $scope.gridNavigateRows();
        }
      }
    };

    // Returns the cached row total — does not query the grid API so it
    // remains accurate even while the grid is rebuilding.
    $scope.gridTotalResources = () => _browseTotalRows || undefined;

    $scope.$on("ResourceService.LaunchFullView", (_, config) => {
      current = config;
      $rootScope['_currentResource'] = config;

      // Hoist grid API to $rootScope before the guard so the inactive instance
      // (RC-child when not yet detached) can restore it in _reloadCurrent on first open.
      if (config.grid && config.grid.api) {
        $rootScope['_browseApi'] = config.grid.api;
        $rootScope['_browseColumnApi'] = config.grid.columnApi;
      }

      $scope._reloadCurrent = () => {
        const res = $rootScope['_currentResource'];
        if (res) {
          if (_initScopeTimeout) {
            $timeout.cancel(_initScopeTimeout);
            _initScopeTimeout = null;
          }
          $scope.index = $rootScope['_browseIndex'];
          if (!_browseApi && $rootScope['_browseApi']) {
            _browseApi = $rootScope['_browseApi'];
            _browseColumnApi = $rootScope['_browseColumnApi'];
            _browseTotalRows = (_browseApi.getInfiniteRowCount ? _browseApi.getInfiniteRowCount() : 0) || _browseTotalRows;
          }
          this.InitializeScope($rootScope, $scope, res.projectId, res.collectionId, res.resourceId, ++this._loadGeneration);
        }
      };

      // Only the active viewer instance should do the actual loading work.
      // When not detached the inline controller (iio-resource-layer) owns the viewer;
      // when detached the child-window controller (iio-child-window) owns it.
      // $_isChildWindow is set via ng-init on the iio-child-window element (post-link,
      // so it must be read lazily here rather than cached in the constructor).
      if (!!$scope['$_isChildWindow'] === !$rootScope.viewerDetached) {
        return;
      }

      resetPreview();
      $rootScope['isLoading'] = true;
      $rootScope['pendingResource'] = (config.title || config.filename)
        ? {title: config.title, filename: config.filename, type: config.type, hasVirus: config.hasVirus}
        : null;


      if (config.grid) {
        // Authoritative row-click from BrowseController — adopt the position
        // and refresh all browse state from the live grid reference.
        $rootScope['_browseIndex'] = config.index;
        if (config.grid.api) {
          _browseApi = config.grid.api;
          _browseColumnApi = config.grid.columnApi;
          _browseTotalRows = _browseApi.getInfiniteRowCount() || _browseTotalRows;
        }
      }
      // Always sync $scope.index from the shared _browseIndex.  For row-clicks
      // _browseIndex was just updated above; for programmatic navigation it was
      // already incremented/decremented by gridNextRow/gridPreviousRow before
      // this broadcast was sent.  Keeping this unconditional ensures the inline
      // controller also tracks the correct position when it receives broadcasts
      // from the detached viewer.
      $scope.index = $rootScope['_browseIndex'];

      if (window === window.current) {
        layerService.pushLayer(layerService.LAYERS.RESOURCE);
      }

      if (!hotkeys.get("alt+q")) {
        navigationService.setActiveTab("projects");

        hotkeys.add({
          combo: "alt+q",
          description: "Close Document",
          callback: () => $scope.close()
        });
        hotkeys.add({
          combo: "right",
          description: "Next Document",
          callback: () => $scope.gridNextRow()
        });
        hotkeys.add({
          combo: "left",
          description: "Previous Document",
          callback: () => $scope.gridPreviousRow()
        });
        hotkeys.add({
          combo: "ctrl+space",
          description: "Tag as 'Reviewed'",
          callback: () => $rootScope.$broadcast("HotKeyEventTriggered", {type: "Tag", value: "Reviewed"})
        });
        hotkeys.add({
          combo: "alt+r",
          description: "Tag as 'Responsive'",
          callback: () => $rootScope.$broadcast("HotKeyEventTriggered", {type: "Tag", value: "Responsive"})
        });
        hotkeys.add({
          combo: "alt+n",
          description: "Tag as 'Not Responsive'",
          callback: () => $rootScope.$broadcast("HotKeyEventTriggered", {type: "Tag", value: "Not Responsive"})
        });
        hotkeys.add({
          combo: "alt+k",
          description: "Tag as 'Confidential'",
          callback: () => $rootScope.$broadcast("HotKeyEventTriggered", {type: "Tag", value: "Confidential"})
        });
        hotkeys.add({
          combo: "alt+p",
          description: "Tag as 'Privileged'",
          callback: () => $rootScope.$broadcast("HotKeyEventTriggered", {type: "Tag", value: "Privileged"})
        });
        hotkeys.add({
          combo: "alt+j",
          description: "Tag as 'Junk'",
          callback: () => $rootScope.$broadcast("HotKeyEventTriggered", {type: "Tag", value: "Junk"})
        });
      }

      if (_initScopeTimeout) {
        $timeout.cancel(_initScopeTimeout);
      }
      const navGen = ++this._loadGeneration;
      _initScopeTimeout = $timeout(() => {
        _initScopeTimeout = null;
        this.InitializeScope($rootScope, $scope, config.projectId, config.collectionId, config.resourceId, navGen);
      }, INIT_SCOPE_DEBOUNCE_MS);

      tagFormService.findByProject(config.projectId, tagForm => {
        $scope.tagAdmin = false;
        $scope.tagForm = tagForm;
      });
    });

    // Tag hotkey callbacks broadcast HotKeyEventTriggered so that whichever
    // ResourceController scope has the resource loaded handles it (scope A, the
    // iio-child-window scope, registers hotkeys first but its $scope.resource may
    // be null mid-load; scope B, the inline viewer, reliably has it set once the
    // resource is visible). args.handled prevents both scopes from firing.
    $scope.$on("HotKeyEventTriggered", (_, args) => {
      if (args.handled || !$scope.resource) {
        return;
      }
      args.handled = true;
      tagService.TagResource($scope.project, $scope.collection, $scope.resource, args.value, false);
    });

    // tags.complete fires on $rootScope after every tagging operation (hotkey or click).
    // TagService.TagResource updates resource.tags only on the object reference it was
    // called with, which may belong to a different ResourceController scope than the one
    // rendering the template. Refreshing here keeps every scope's resource.tags in sync.
    $scope.$on("tags.complete", () => {
      if ($scope.resource && current.resourceId) {
        tagService.FindResourceTags(current.projectId, current.collectionId, current.resourceId,
          (tags) => this.$timeout(() => {
            $scope.resource.tags = tags;
          }));
      }
    });

    $scope.$on("DataGridReadyEvent", (_, params) => {
      if (params.name === "messagesGrid") {
        if (!$scope.viewInConversation) {
          $scope.messagesDataSource = null;
        }

        $scope.messagesGridApi = params.api;
      }
    });

    $scope.$on("DataGridFirstPageRenderedEvent", async (_, params) => {
      if (!$scope.viewInConversation) {
        $scope.chatMessageId = params.data?.mostRecentMessage?.messageId;
        $scope.scrollToBottom = true;
        $scope.messagesDataSource = {...messageDataSource};

        if ($scope.resource.type === "phone image metadata") {
          $scope.conversationTags = await tagService.GetConversationTags($scope.project, $scope.collection, $scope.resource, $scope.chatMessageId);
          $scope.conversationTags = $scope.conversationTags.data;
        }
      }
    });

    $scope.$on("DataGridGroupedRowSelectedEvent", (_, params) => {

      if (params.data && params.data._class) {
        switch (params.data._class) {
          case "SearchTermGroupedItem":
            this.HighlightTerm(params.data as SearchTermGroupedItem).then((highlights) => {
              $timeout(() => {
                console.log("data", params.data);
                $scope.termHighlights = {
                  term: params.data.term,
                  snippets: highlights,
                  selectedIndex: -1
                }
                // $scope.termHighlights = highlights;
                //$scope.$selectedSnippetIndex = -1;
              });
            });
            break;
          default:
            break;
        }

      } else {

        const annotatedTextContainer = $(".annotated-text");

        if (annotatedTextContainer.length === 0) {
          return;
        }

        const entity = $(`${params.data.type.value}:contains(${params.data.value})`);

        $scope.highlightedEntities.push(entity);

        $scope.highlightedEntities.forEach(e => e.removeClass());

        entity.addClass(`highlight-${params.data.type.value}`)
      }
    });

    $scope.$on("DataGridRowSelectedEvent", (_, params) => {
      if (params.data.conversationId) {
        $timeout(async () => {
          $scope.chatMessageId = params.data?.mostRecentMessage.messageId;
          $scope.messagesDataSource = {...messageDataSource}
          $scope.selectedRows = null;
          $scope.conversationTags = await tagService.GetConversationTags($scope.project, $scope.collection, $scope.resource, $scope.chatMessageId);
          $scope.conversationTags = $scope.conversationTags.data;
        }, 100);
      } else if (params.data.resourceId) {
        $timeout(() => $scope.selectedRows = $scope.messagesGridApi.getSelectedRows());
      } else {
        $scope.$broadcast("ResourceService.LaunchFullView", {
          projectId: params.data.projectId,
          collectionId: params.data.collectionId,
          resourceId: params.data.id,
          title: params.data.title,
          filename: params.data.filename,
          type: params.data.type,
          hasVirus: params.data.hasVirus,
        });
      }
    });

    $scope.$on("DataGridRowCheckedEvent", (e, params) => {
      $scope.resources = _.map(params.grid.api.getSelectedRows(), (r: IResource) => r.id);
    });

    $scope.$on("FeedService.TaggingComplete", async _ => {
      if ($scope.chatMessageId && $scope.chatMessageId !== "") {
        $scope.conversationTags = await tagService.GetConversationTags($scope.project, $scope.collection, $scope.resource, $scope.chatMessageId);
        $scope.conversationTags = $scope.conversationTags.data;
      }
    });

    $scope.$on("FeedService.UntaggingComplete", async _ => {
      if ($scope.chatMessageId && $scope.chatMessageId !== "") {
        $scope.conversationTags = await tagService.GetConversationTags($scope.project, $scope.collection, $scope.resource, $scope.chatMessageId);
        $scope.conversationTags = $scope.conversationTags.data;
      }
    });

    $scope.onPlayerReady = API => {
      $scope.player.API = API;
      // Stub out clearMedia() on the API instance to prevent videogular's
      // $routeChangeStart listener from blanking video.src.
      API.clearMedia = () => {
      };
    };

    $scope.onPlayerError = event => console.log(event);

    $scope.$watch("newResourceNote.note", (after, before) => $scope.pendingChanges.notes = before !== after && after !== "", true);

    $scope.$watch("preview.type", () => {
      $scope.highlightedCategories = [];
      $scope.highlightedEntities = [];
    }, true);

    $scope.$watch("resource.id", newResource => {
      if (newResource) {
        $scope.highlightedCategories = [];
        $scope.highlightedEntities = [];

        if (configService.getFullViewMode() === "direct") {
          $scope.richSrc = resourceText.richSrc(current.projectId, current.collectionId, current.resourceId);
          $scope.downloadUri = $scope.resource.directNativePath;
          $scope.plainSrc = $scope.resource.directTextPath;
          $scope.annotatedPlainSrc = $scope.resource.directAnnotatedHtmlPath;
          $scope.pdfSrc = $scope.resource.directPdfPath;
        } else {
          $scope.richSrc = resourceText.richSrc(current.projectId, current.collectionId, current.resourceId);
          $scope.downloadUri = resourceService.GetDownloadUri(current.projectId, current.collectionId, current.resourceId);
          $scope.plainSrc = resourceText.plainSrc(current.projectId, current.collectionId, current.resourceId);
          $scope.pdfSrc = resourceText.pdfSrc(current.projectId, current.collectionId, current.resourceId);
        }

        configurePlayer();
        refreshNotes();
      }
    }, true);

    $scope.$on("RemoveTag", (evt, tag) => {
      if ($scope.resource.type === "phone image metadata") {
        notificationService.addSuccess({
          title: "Untagging Started",
          description: `Removing ${tag.name} from conversation.`,
          timeout: 2500
        });
      }

      evt.stopPropagation();
      tagService.UntagResource($scope.project, $scope.collection, $scope.resource, $scope.chatMessageId, tag, null, preferenceService.Get(Preferences.TAG_RELATED));
    });

    $scope.getContainerHeight = () => {
      const w = window.current || window;
      return w.document && w.document.documentElement ? $(w).height() : $(window).height();
    };

    // for our metadata test
    $scope.isEmpty = obj => angular.equals({}, obj);

    $scope.popIn = () => {
      // Chrome doesn't reliably fire the popup's onunload for a scripted
      // window.close(), which is the only thing that used to reset
      // viewerDetached — run the reattach logic directly instead of
      // depending on that event.
      if ($rootScope['_childWindowClose']) {
        $rootScope['_childWindowClose']();
      } else {
        window.current.close();
      }
    };

    $scope.saveRowSelection = () => {
      if ($scope.selectedRows && $scope.selectedRows.length > 0) {
        $scope.savingConversation = true;
        resourceService.SaveConversation($scope.resource, $scope.selectedRows);
        $timeout(() => $scope.savingConversation = false, 2000);
      } else {
        notificationService.addError({
          title: "Please select the messages you would like to extract.",
          timeout: 5000
        });
      }
    };

    $scope.saveEntireConversation = () => {
      const message = $scope.messagesGridApi.getDisplayedRowAtIndex(0);
      $scope.savingConversation = true;
      resourceService.SaveEntireConversation($scope.resource, message.data.resourceId);
      $timeout(() => $scope.savingConversation = false, 2000);
    };

    $scope.close = () => {
      $scope.highlightedCategories = [];
      $scope.viewInConversation = false;
      $scope.conversationsFocusRowIndex = 0;

      if ($scope.pendingChanges.redaction || $scope.pendingChanges.notes) {
        $scope.disregardChanges = () => {
          $scope.pendingChanges.redaction = false;
          $scope.pendingChanges.notes = false;
          $scope.instance.close();
          $scope.close();
        };

        $scope.instance = $uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/controls/pending-redactions-notes.html",
          scope: $scope,
          appendTo: $(window.current.document.body)
        });
      } else {
        $scope.newResourceNote.note = "";
        if (window.current !== window) {
          if ($rootScope['_childWindowClose']) {
            $rootScope['_childWindowClose']();
          } else {
            window.current.close();
          }
        } else {
          layerService.popLayer();
        }

        resetPreview();
        $scope.tagForm = null;
        if ($scope.player.API) {
          $scope.player.API.stop();
        }
        $rootScope.$broadcast("fullview.closed");
      }
    };

    $scope.detach = () => {
      $rootScope.viewerDetached = true;

      layerService.popLayer();
    };

    $scope.saveNote = note => {
      $scope.savingNote = true;

      const newNote = resourceNoteService.create(current.projectId, current.collectionId, current.resourceId, $scope.noteCategoryConfig.selected.id, note.note);
      resourceNoteService.save(newNote, () => {
        note.note = "";
        $scope.savingNote = false;
        refreshNotes();
      }, () => $scope.savingNote = false);
    };

    $scope.removeNote = note => resourceNoteService.delete(note, () => refreshNotes());

    $scope.reprocess = () => {
      if ($scope.reprocessSubmit) return;

      $scope.reprocessSubmit = true;
      resourceService.Reprocess($scope.resource, () => $scope.reprocessSubmit = false);
    };

    $scope.replacePdf = () => {
      $uibModal.open({
        backdrop: true,
        keyboard: true,
        backdropClick: true,
        templateUrl: "partials/review/dialog_replacepdf.html",
        controller: "ReplacePdfModalController",
        scope: $scope,
        resolve: {
          project: () => $scope.project,
          resource: () => $scope.resource
        }
      });
    };

    $scope.showHotkeys = () => {
      const hk = hotkeys.get("?");
      if (hk) hk.callback();
    };

    $scope.$on("resource-translation-editor-save-triggered", () => {
      translationService.Save($scope.translation).then(() => {
        notificationService.addSuccess({
          title: "Translated Text Successfully Saved.",
          timeout: 5000
        });
      }).catch(() => {
        notificationService.addSuccess({
          title: "Translated Text Failed to Save.",
          timeout: 5000
        });
      });
    });

    $rootScope.$on("viewerDetached", (_, value) => {
      if (!value) {
        window["current"] = window;

        // detach() pops the RESOURCE layer off the stack so the inline
        // .iio-resource-layer div (ng-show="layer.current == 'resource' && ...")
        // hides while detached. Nothing else re-pushes it, so it must happen
        // here on every re-attach — whether the user clicked "pop in" or just
        // closed the popup window — or the inline viewer stays hidden until
        // a page refresh even though viewerDetached is now false.
        layerService.pushLayer(layerService.LAYERS.RESOURCE);

        // Reload the resource content on this (inline) scope using the
        // shared _currentResource — this mirrors what _reloadCurrent does
        // for the detach direction. Also call gridNavigateRows to restore
        // the grid's scroll/focus position. Run regardless of how the
        // detached window closed (pop-in button or the window's own close),
        // since both should return the viewer to the main window.
        $scope._reloadCurrent();
        $scope.gridNavigateRows();
      }
    });

    $scope.tagFormSwitch = {
      "tagRelated": preferenceService.Get(Preferences.TAG_RELATED)
    };

    $scope.$on(PreferenceService.GetEventForPreference(Preferences.TAG_RELATED), (_, val) => $scope.tagFormSwitch.tagRelated = val);

    $scope.$watch("tagFormSwitch.tagRelated", val => preferenceService.Set(Preferences.TAG_RELATED, val));

    $scope.searchSnippet = (index, snippet) => {
      $scope.$selectedSnippetIndex = index;
      $rootScope.$broadcast("fullview.search", snippet);
    };

    $scope.searchTermSnippet = (index, snippet) => {
      $scope.termHighlights.selectedIndex = index;
      $rootScope.$broadcast("fullview.search", snippet);
    };

    $scope.autoTranslate = () => {
      $scope.autoTranslating = true;

      translationService.AutoTranslate({
        projectId: current.projectId,
        collectionId: current.collectionId,
        resourceId: current.resourceId,
        sourceLanguage: $scope.translationConfig.sourceLanguage.id
      })
        .then(() => {
          translationService.FindOne({
            projectId: current.projectId,
            collectionId: current.collectionId,
            resourceId: current.resourceId
          })
            .then(translation => {
              $.extend($scope.translation, translation);
              notificationService.addSuccess({
                title: "Auto-Translated Text Successfully Saved.",
                timeout: 5000
              });
            }).catch(msg => console.log("catch error on findone: ", msg));

          $scope.autoTranslating = false;

        }).catch(msg => {
        console.log("Catch on auto: ", msg);
        $scope.autoTranslating = false;
      });
    };
  }

  private async InitializeScope($rootScope, $scope, projectId: string, collectionId: string, resourceId: string, myGen: number) {

    const promise1 = this.projectService.FindOne({id: projectId});
    const promise2 = this.collectionService.FindOne({
      id: collectionId,
      projectId: projectId
    });
    const promise3 = this.resourceService.FindThread(projectId, collectionId, resourceId);
    const promise4 = this.translationService.FindOne({
      projectId: projectId,
      collectionId: collectionId,
      resourceId: resourceId
    });
    const promise5 = this.resourceService.FindOne({
      id: resourceId,
      collectionId: collectionId,
      projectId: projectId
    });


    const [project, collection, thread, translation, resource] = await Promise.all([promise1, promise2, promise3, promise4, promise5])
      .catch(e => {
        $rootScope['isLoading'] = false;
        $rootScope['pendingResource'] = null;
        throw e;
      });

    // Discard if a newer navigation started while these requests were in flight.
    if (myGen !== this._loadGeneration) {
      return;
    }

    this.$timeout(async () => {
      if (myGen !== this._loadGeneration) {
        $rootScope['isLoading'] = false;
        $rootScope['pendingResource'] = null;
        return;
      }

      $rootScope['isLoading'] = false;
      $rootScope['pendingResource'] = null;
      $scope.project = project;
      $scope.collection = collection;
      $scope.resource = resource;
      $scope.threads = thread;
      $scope.childDocumentCount = 0;

      // Clear stale translation props before merging so keys absent in the
      // new translation don't persist from a previous document.
      Object.keys($scope.translation).forEach(k => {
        delete $scope.translation[k];
      });
      $.extend($scope.translation, translation);

      if ($scope.preview.type === "EndorsedPdf" && !$scope.resource.resourceBates.length) {
        $scope.preview.type = "Pdf";
      }

      if ($scope.preview.type === "EndorsedPdf") {
        const bates = _.find($scope.resource.resourceBates, (b: any) => b.exportId === $scope.bates.exportId);

        if (bates) {
          $scope.endorsedPdfSrc = bates.directEndorsedPdfPath;
          $scope.endorsedPdfTitle = `Export Name: ${bates.name}`;
        } else {
          $scope.endorsedPdfSrc = null;
          $scope.endorsedPdfTitle = "";

          this.notificationService.addError({
            title: `The current resource does not belong to export ${$scope.bates.name}`,
            timeout: 5000
          });
        }
      }

      if ($rootScope.query && $rootScope.query()) {
        try {
          const hl = await this.resourceService.FindHighlights(projectId, collectionId, resourceId, $rootScope.query());
          // Assign as long as we're still viewing the resource these highlights belong to.
          // Guard on resource identity, NOT generation: _reloadCurrent re-bumps the generation
          // for the *same* resource (e.g. on viewer attach), so a generation check would wrongly
          // discard valid highlights and leave Search Hits empty. A real navigation to a different
          // resource changes $scope.resource.id, which still correctly discards this stale result.
          if (!$scope.resource || $scope.resource.id !== resourceId) {
            return;
          }
          // We're in a post-await continuation, outside Angular's digest, so a bare assignment
          // updates the model but never re-evaluates ng-if="highlights.length > 0" — the section
          // only appeared when some unrelated digest happened to fire (the intermittent empty).
          // Assign inside $timeout so a digest runs and Search Hits renders deterministically.
          this.$timeout(() => { $scope.highlights = hl; });
        } catch (e) {
          // Don't let a failed highlights fetch abort the rest of the resource load.
          console.error("FindHighlights failed", e);
        }
      }


      $scope.tooltipText = $scope.project.status === Status.Active ? "Download" : "Active Projects Only"

      if ($scope.resource && $scope.resource.type === "phone image metadata") {
        $scope.resourceTitle = $scope.resource.custodianName;
        $scope.resourceBasename = $scope.resource.filename.replace(".xml", "");
        $scope.unsupportedElements = "";

        if ($scope.resource.unsupportedElements) {
          $scope.resource.unsupportedElements.forEach(s => $scope.unsupportedElements += `<div><i class="fas fa-code"></i> <small>${s}</small><br></div>`);
        }
      }
    });

    if (myGen !== this._loadGeneration) {
      return;
    }

    $scope.childrenDataSource = {
      rowCount: null,
      getRows: async params => {
        const children = await this.resourceService.GetChildren(projectId, collectionId, $scope.resource.id, Math.floor(params.startRow / 20), 20);
        $scope.childDocumentCount = children.totalResources;
        this.$timeout(() => params.successCallback(children.resources, children.totalResources), 20);
      }
    };

    $scope.parentsDataSource = {
      rowCount: null,
      getRows: params => params.successCallback($scope.resource.parents, $scope.resource.parents.length)
    };

    $scope.conversationsDataSource = {
      rowCount: null,
      getRows: async params => {
        const response = await this.resourceService.GetConversations($scope.resource, Math.floor(params.startRow / 20), 20);
        params.successCallback(response.conversations, response.total);
      }
    };

    $scope.namedEntitiesDataSource = {
      rowCount: null,
      getRows: async params => {
        const response = await this.resourceService.FindNamedEntities($scope.resource.projectId, $scope.resource.collectionId, $scope.resource.id, Math.floor(params.request.startRow / 20), 20, params.request.rowGroupCols[0]?.id, params.request.groupKeys[0]);

        response.expandedGroupItems?.forEach(g => g.value = titleCase(g.value));

        if (params.request.groupKeys.length === 0) {
          $scope.totalNamedEntityGroupCount = response.totalGroupCount;
        }

        params.successCallback(response.groups ?? response.expandedGroupItems, response.totalGroupCount ?? response.totalExpandedGroupItemCount);
      }
    };

    $scope.similarDataSource = {
      rowCount: null,
      getRows: async params => {
        const similar = await this.resourceService.FindSimilar(projectId, collectionId, resourceId, Math.floor(params.startRow / 20), 20);
        $scope.similarDocumentCount = similar.resources.length;
        this.$timeout(() => params.successCallback(similar.resources, similar.totalResources), 200);
      }
    };

    $scope.threadsDataSource = {
      rowCount: null,
      getRows: params => params.successCallback($scope.threads, $scope.threads.length)
    };

    $scope.searchTermListsDataSource = {
      rowCount: null,
      getRows: params => {
        let response = {
          "rows": [],
          "totalRows": 0
        }

        if (params.request.groupKeys.length == 0) {
          response.totalRows = $scope.resource.searchTermLists.length;
          $scope.resource.searchTermLists.forEach((stl: SearchTermList) => {
            response.rows.push(new SearchTermListGroupedItem(stl, new GroupedType(stl.id, stl.name)));
          })
        } else {
          const searchTermListId: string = params.request.groupKeys[0];
          const foundList: any = $scope.resource.searchTermLists.find((stl: SearchTermList) => stl.id === searchTermListId);
          if (foundList) {
            response.totalRows = foundList.searchTerms.length;
            foundList.searchTerms.forEach((st: SearchTerm) => {
              response.rows.push(new SearchTermGroupedItem(st, new GroupedType(foundList.id, foundList.name), $scope.resource.collectionId, $scope.resource.id));
            });
          }
        }

        params.successCallback(response.rows, response.totalRows);
      }
    };

    $scope.updateSelectedTab = ($event, tabName) => {
      if (tabName === "Analytics") {
        $scope.selectedTab = tabName;
      }
    }
    ;
    $scope.setEndorsedPdf = bates => {
      $scope.bates = bates;
      $scope.endorsedPdfSrc = bates.directEndorsedPdfPath;
      $scope.endorsedPdfTitle = `Export Name: ${bates.name}`;
      $scope.preview.type = 'EndorsedPdf';
    }
  }

  private async HighlightTerm(term: SearchTermGroupedItem) {
    return await this.resourceService.FindHighlightsForTerm(term.projectId, term.collectionId, term.resourceId, term.id);
  }
}

frontendApp.controller("ResourceController", ["$rootScope", "$scope", "$uibModal", "$sce", "$http", "$window", "$timeout", "$compile", "hotkeys", "ProjectService", "OrganizationService", "CollectionService", "ResourceService", "ResourceText", "ResourceNoteService", "NavigationService", "LayerService", "TagService", "AccountService", "ConfigService", "HttpService", "NotificationService", "TagFormService", "TranslationService", "PreferenceService", Factory.Create(ResourceController)]);
